import { useState } from 'react';
import { addressHistory, checklist } from '@/mocks/home';

export default function AddressSection() {
  const [checked, setChecked] = useState<number[]>([]);

  const toggle = (index: number) => {
    setChecked((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  const progress = Math.round((checked.length / checklist.length) * 100);

  return (
    <section id="address" className="scroll-mt-24 border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-secondary-600">Address Log</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新可用地址与更新记录</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            下表记录近期各线路的巡检结果与调整情况。拿到一个地址后，先对照右侧核对清单逐项确认，
            确认无误再将地址加入收藏夹。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.4fr_1fr]">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h3 className="font-heading text-lg font-semibold text-foreground-950">线路更新记录</h3>
            <div className="mt-5 space-y-1">
              {addressHistory.map((row) => (
                <div key={`${row.date}-${row.label}`} className="flex items-start gap-4 rounded-md px-3 py-3 transition-colors hover:bg-background-100">
                  <div className="flex w-20 shrink-0 flex-col">
                    <span className="text-xs font-medium text-foreground-500">{row.date}</span>
                  </div>
                  <div className="flex flex-1 flex-wrap items-center gap-2">
                    <span className="font-medium text-foreground-950">{row.label}</span>
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">{row.status}</span>
                  </div>
                  <p className="hidden flex-1 text-sm text-foreground-600 md:block">{row.note}</p>
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs text-foreground-500">说明：记录为近期巡检的汇总信息，具体以官方公告为准。</p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">地址核对清单</h3>
              <span className="text-sm font-medium text-primary-700">{progress}%</span>
            </div>
            <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
              <div className="h-full rounded-full bg-primary-500 transition-all duration-300" style={{ width: `${progress}%` }} />
            </div>
            <ul className="mt-5 space-y-2">
              {checklist.map((item, index) => {
                const isChecked = checked.includes(index);
                return (
                  <li key={item}>
                    <button
                      type="button"
                      onClick={() => toggle(index)}
                      aria-pressed={isChecked}
                      className={`flex w-full items-start gap-3 rounded-md border px-3 py-2.5 text-left text-sm transition-colors ${
                        isChecked
                          ? 'border-primary-200 bg-primary-50 text-foreground-900'
                          : 'border-background-200 bg-background-50 text-foreground-700 hover:bg-background-100'
                      }`}
                    >
                      <i
                        className={isChecked ? 'ri-checkbox-fill mt-0.5 text-base text-primary-600' : 'ri-checkbox-blank-line mt-0.5 text-base text-foreground-400'}
                        aria-hidden="true"
                      />
                      <span>{item}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
            <p className="mt-4 text-xs leading-relaxed text-foreground-500">
              {progress === 100 ? '全部核对通过，可以将该地址加入收藏夹保存。' : '全部核对通过后，再将该地址保存为书签。'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}